import { alarmToColor } from '../../utils/AlarmUtils';

export const tickFormatter = (value: string) => {
  const parsedValue = parseInt(value, 10);
  if (parsedValue > 1000000) {
    const valueInMillion = parsedValue / 1000000;
    return `${valueInMillion}M`;
  }
  return parsedValue.toString();
};

export const procPieData: any = (pieData: any) => {
  pieData?.forEach((dat: any) => {
    if (dat && dat.children) {
      dat.fill = alarmToColor(dat.id);
      dat?.children.forEach((cDat: any) => {
        cDat.fill = alarmToColor(cDat.id);
      });
    }
  });
  return pieData;
};
